import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

/**
 * The connections list without suspense, for callers mounted outside a Suspense
 * boundary. Prefer the suspense variants where a boundary exists.
 */
export const useGetOnlineAccounts = () => {
    const stateKey = useStateKey();

    return useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey })
    });
};
